import { render } from "./WhatsappSettings.vue?vue&type=template&id=49c32060"
import script from "./WhatsappSettings.vue?vue&type=script&lang=js"
export * from "./WhatsappSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__